import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { DcSpinnerService } from '../common/services';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(public router: Router, public spinnerService: DcSpinnerService) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem('auth_access_token')) {
        this.router.navigate(['']);
        return resolve(false);
      }

      this.spinnerService.stop();
      resolve(true);
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/login/guard.service.ts